import { Roles } from '@/core/types';
import RolesGuard from '@/router/guards/RolesGuard';
import { RouteObject } from 'react-router-dom';
import LocationsPage from '@/views/pages/locations/index';
import LocationPage from '@/views/pages/locations/location';

export default [
	{
		path: 'locations',
		element: <RolesGuard roles={[Roles.SITE_SUPERVISOR]} element={<LocationsPage />} />,
	},
	{
		path: 'locations/:locationId',
		element: <RolesGuard roles={[Roles.SITE_SUPERVISOR]} element={<LocationPage />} />,
	},
] as RouteObject[];
